import { ajax } from './ajax.function';

const applyQueryParameters = (params: Record<string, any>): string => Object.keys(params).map(param => `${param}=${params[param]}`).join('&');

export const get = (url: string, data?: Record<string, any>, authorization?: string) => ajax('GET', `${url}${data ? `?${applyQueryParameters(data)}` : ''}`, data, authorization);
